﻿import comboListTemplate from '../templates/comboList.html';

function comboListDirective() {
    return {
        restrict: 'E',
        controller: 'ComboListCtrl',
        controllerAs: 'combo',
        bindToController: true,
        scope: {
            productId: '@',
            onChangeEditMode: '&',
            onInit:'&',
            onChangePrice:'&',
            currencySymbol: '@',
        },
        templateUrl: comboListTemplate,
        link: function (scope, element, attrs, ctrl) {
            if(ctrl.productId) {
                ctrl.getComboList(Number(ctrl.productId));
            }
        },
    };
}

export { comboListDirective };
